import { type AxiosInstance } from "axios";
import { REGISTRY_CHANGE_ALERTS_ENDPOINT } from "@/features/registryChangeAlert/api/GetRegistryChangeAlertsAPI";
import { FETCH_ALL_PAGE_SIZE } from "@/features/registryChangeAlert/utils/constants";
import type {
  GetRegistryChangeAlertsAPIResponse,
  RegistryChangeAlertEntity,
} from "@/features/registryChangeAlert/types";

/**
 * 絞り込み条件に一致する変動アラートを全件取得する（全件をまとめてリユース取得するため）。
 * ID を起点に順に読むため、途中でアラートが増減しても取りこぼし・重複が起きない。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {string | undefined} pictureType 謄本種別の絞り込み
 * @returns {Promise<RegistryChangeAlertEntity[]>}
 */
export const FetchAllRegistryChangeAlertsAPI = async (
  apiClient: AxiosInstance,
  pictureType: string | undefined
): Promise<RegistryChangeAlertEntity[]> => {
  const alerts: RegistryChangeAlertEntity[] = [];
  let afterId = 0;
  for (;;) {
    const { data } = await apiClient.get<GetRegistryChangeAlertsAPIResponse>(
      REGISTRY_CHANGE_ALERTS_ENDPOINT,
      { params: { pictureType, afterId, pageSize: FETCH_ALL_PAGE_SIZE } }
    );
    alerts.push(...data.items);
    if (data.items.length < FETCH_ALL_PAGE_SIZE) {
      return alerts;
    }
    afterId = data.items[data.items.length - 1].id;
  }
};
